'use strict';

module.exports = function (selector, keyFunctions, preFunction) {
    $(selector).on('keydown', function (e) {
        var key = e.which;
        var supportedKeyCodes = [37, 38, 39, 40, 27, 9];
        if (supportedKeyCodes.indexOf(key) >= 0) {
            e.preventDefault();
        }
        var returnedScope = preFunction.call(this);
        // Check if SHIFT + TAB is pressed
        if (key === 9 && e.shiftKey) {
            if (keyFunctions['SHIFT+TAB']) {
                keyFunctions['SHIFT+TAB'].call(this, returnedScope);
            }
        } else {
            // Handle other keys as before
            keyFunctions[key].call(this, returnedScope);
        }
    });
};
